
import ImageHeader from '@/components/core/ImageHeader';
import tableLoading from '@/components/tableLoading';
import NoContent from '@/components/customer-content/NoContent';
import ExploreCard from '@/components/ExploreCard';
export default {
  scrollToTop: true,
  components: {
    ImageHeader,
    tableLoading,
    NoContent,
    ExploreCard
  },
  head() {
    return {
      title: this.seoData && this.seoData.title ?  this.seoData.title : 'Goa App',
      meta: [{
            hid: 'description',
            name: 'description',
            content:  this.metaDesc()
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.metaKeywords()
          },
          {
            hid: 'image',
            property: 'image',
            content:  this.metaImage()
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: this.seoData && this.seoData.title ?  this.seoData.title : 'Goa App',
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.metaImage()
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:  this.metaDesc()
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.seoData && this.seoData.title ?  this.seoData.title : 'Goa App',
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:  this.metaDesc()
          }
        ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      pageData: {
        attractions: [],
      },
      listings: {},
      schemaData: [],
      loading: true,
      listingLoading: true,
      activityCat: null,
      pageTitle: '',
      pageSubTitle: '',
      seoData: null,
    };
  },
  async validate({
    params,
    store
  }) {
    // await operations
    if (params.category != (null || "")) {
      this.activityCat = params.category;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.activityCat = this.$route.params.category;
    if (!this.activityCat) {
      this.$router.push({
        path: '/'
      });
    }
  },
  async fetch() {
      this.seoData = await fetch(this.$config.fetchUrl + '/api/attractions/seo/getSEOContent/' + this.activityCat)
      .then(res => res.json()).catch(error => {
        console.error("There was an error!", error); return false;
      });
    },
  jsonld() {
    return this.getJsonData()
  },
  mounted() {
    document.body.classList.add('modalOverflow');
    if (localStorage.getItem("plcData")) {
        localStorage.removeItem('plcData');
      }
    this.getAllData();
  },
  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    metaDesc() {
        if (this.seoData && this.seoData.description) {
        return this.seoData.description
        } else {
          return 'Looking for the must visit places and must do activities in Goa ? Goa App offers all that you need to know about the Beaches, Old Goa Churches Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals etc. Check out the top things to do in Goa only on Goa App.'
        }
      },
      metaKeywords() {
        if (this.seoData && this.seoData.keywords) {
        return this.seoData.keywords;
        } else {
          return 'Goa, Goa Tourism, Travel Guide, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Old Goa Churches, Offers, Travel Goa, Visit goa, Car rentals, Bike Rentals, Top things to do in Goa, Travel Agency'
        }
      },
      metaImage(){
        if (this.seoData && this.seoData.image) {
        return this.seoData.image;}
        else{
          return 'https://goa.app/img/explore/explore-goa.webp'
        }
      },

    async getAllData(){
      this.listings = await fetch(this.$config.fetchUrl + '/api/attractions/getAttractionBySlug/' + this.activityCat)
      .then(res => res.text()).catch(error => {
        //this.$router.push({
//          path: '/'
//        })
        console.error("There was an error!", error); return false;
      });
      this.listings = this.getCryptKey(this.listings);
      this.$nextTick(() => {
        if(this.listings){
          this.pageTitle = this.listings.name
          this.pageSubTitle = this.listings.shortDescription
          this.pageData.attractions.push(this.listings)
          this.schemaData = this.listings && this.listings.posts ? this.listings.posts : [];
        }
        this.listingLoading = false;
        console.log(this.listings)
      })
    },
    getJsonData() {
      if(!this.schemaData){
      return null
    }
      return {
        "@context": "http://schema.org",
        "@graph":
        [             
          {
              "@type": "ImageObject",
              "@id": this.metaImage(),
              "url": this.metaImage(),
              "contentUrl": this.metaImage(),
              "caption": this.pageTitle,
              "inLanguage": "en-US",
              "width": 1200,
              "height": 630
            },
            {
              "@type": "WebPage",
              "@id": `https://www.goa.app/explore/${this.activityCat}/#webpage`,
              "url": `https://www.goa.app/explore/${this.activityCat}`,
              "name": this.pageTitle,
              "description": this.pageSubTitle,
              "image": this.metaImage(),
              "inLanguage": 'English',
              "datePublished": this.listings.createdAt ? this.listings.createdAt : new Date(),
              "dateModified": this.listings.createdAt ? this.listings.createdAt : new Date(),
              "author": {
                "@type": "Person",
                "@id": "https://goa.app",
                url: "https://goa.app"
              },
              "potentialAction": [{
              "@type": "ReadAction",
              "target": [`https://www.goa.app/explore/${this.activityCat}`]
              }]
            },

            {
                "@type": "ItemList",
                "description": this.pageSubTitle,
                "url": `https://www.goa.app/explore/${this.activityCat}`,
                "name": this.pageTitle,
                itemListElement: this.schemaData.map((itm) => ({
                  '@type': 'TouristAttraction',
                  "name" : itm.title ? itm.title : 'Goa App',
                  "description": itm.shortDescription ? itm.shortDescription : 'Goa App',
                  "image": itm.gallery ? itm.gallery : [],
                  "publicAccess": true,
                  "isAccessibleForFree": true,
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress":  itm.location ? itm.location.address : '',
                    "addressLocality": "Goa",
                    "postalCode": "403001",
                    "addressCountry": "IN"
                },
                  "geo": {
                    "@type": "GeoCoordinates",
                    "latitude":itm.location ? itm.location.latitude : '',
                    "longitude": itm.location ? itm.location.longitude : ''
                },
                  "availableLanguage": [
                        {
                                "@type": "Language",
                                "name": "Hindi"
                        },
                        {
                                "@type": "Language",
                                "name": "English"
                        }
                ]
              })),
              "itemListOrder": "http://schema.org/ItemListOrderAscending",
              "numberOfItems": this.schemaData.length,
            }]
          }
    },
    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },
    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    // TO get SUBSCRIPTIONS using pagination
    getListings() {
      this.listingLoading = true;

      // Add header for the API
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      this.$axios.get(
          `/api/attractions/getAttractionBySlug/${this.activityCat}`
        )
        .then(response => {
          let value = this.getCryptKey(response.data);
          this.listings = value ? value : null;
          if(this.listings){
            this.pageTitle = this.listings.name
            this.pageSubTitle = this.listings.shortDescription
            this.pageData.attractions.push(this.listings)
          }
          this.$nextTick(() => {
            this.scrollToSectionIntoView('listing-card');
            this.listingLoading = false;
          })
        })
        .catch(error => {
          this.$nextTick(() => {
            this.listingLoading = false;
          })
        })
        .finally(() => {
          this.$nextTick(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            this.listingLoading = false;
          })
        })
    },
  }
}
